import React, { useEffect, useState } from "react";

const WhatsAppOpener = ({
  jobNo,
  reportNo,
  labRequestId,
  loggedUserData,
  contactNo,
}) => {
  const [phoneNumber, setPhoneNumber] = useState(contactNo);
  const [message, setMessage] = useState("");

  const openWhatsAppWeb = () => {
    // Remove any non-digit characters except the + sign
    let cleanNumber = phoneNumber.replace(/[^\d+]/g, "");

    if (!cleanNumber) {
      alert("Please enter a valid phone number");
      return;
    }

    if (cleanNumber.startsWith("0")) {
      cleanNumber = "+94" + cleanNumber.substring(1);
    }

    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);

    // Format for WhatsApp Web: https://web.whatsapp.com/send?phone=<number>&text=<message>
    const whatsappWebUrl = `https://web.whatsapp.com/send?phone=${cleanNumber}${
      message ? `&text=${encodedMessage}` : ""
    }`;

    // Open in new tab - this will always open WhatsApp Web
    window.open(whatsappWebUrl, "_blank", "noopener,noreferrer");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    openWhatsAppWeb();
  };

  useEffect(() => {
    if (reportNo.startsWith("QC")) {
      setMessage(
        `The Concrete Cube Test report for job no - ${jobNo} has been completed.

Download the report using the link below:
( පහත ලින්ක් එක මගින් වාර්තාව බාගත කරගන්න. )

🔗 Download Report
https://matlab.lk?labRequestId=${labRequestId}&reportNo=${reportNo}

We sincerely appreciate your continued trust and business.
${loggedUserData}
Material Testing Laboratory Team - Kekirawa
`
      );
    } else {
      setMessage(
        `The Invoice for job no - ${jobNo}.

Download the invoice using the link below:
( පහත ලින්ක් එක මගින් කුවිතාන්සිය බාගත කරගන්න. )

🔗 Download Invoice
https://matlab.lk?labRequestId=${labRequestId}&reportNo=${reportNo}

We sincerely appreciate your continued trust and business.
${loggedUserData}
Material Testing Laboratory Team - Kekirawa
`
      );
    }
  }, []);

  return (
    <div style={{ padding: "20px", maxWidth: "500px" }}>
      <h2>Open WhatsApp Web Chat</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "15px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "5px",
              fontWeight: "bold",
            }}
          >
            Phone Number:
          </label>
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="Enter phone number with country code (e.g., +1234567890)"
            style={{
              padding: "10px",
              width: "100%",
              borderRadius: "4px",
              border: "1px solid #ccc",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "5px",
            }}
          >
            <label style={{ fontWeight: "bold" }}>Message (Optional):</label>
            {/* <button
              type="button"
              onClick={handleExampleMessage}
              style={{
                padding: "5px 10px",
                backgroundColor: "#f0f0f0",
                border: "1px solid #ccc",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "12px",
              }}
            >
              Use Example
            </button> */}
          </div>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Enter your message (optional)"
            rows="15"
            style={{
              padding: "10px",
              width: "100%",
              borderRadius: "4px",
              border: "1px solid #ccc",
              boxSizing: "border-box",
              resize: "vertical",
              fontFamily: "inherit",
            }}
          />
        </div>

        <button
          type="submit"
          style={{
            padding: "12px 24px",
            backgroundColor: "#25D366",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "16px",
            width: "100%",
          }}
        >
          Open WhatsApp Web
        </button>
      </form>

      <div style={{ marginTop: "20px", fontSize: "14px", color: "#666" }}>
        <p>
          <strong>Note:</strong> This will open WhatsApp Web in a new tab with
          your pre-filled message.
        </p>
        <p>
          Make sure you're logged into WhatsApp Web in your browser for this to
          work.
        </p>
      </div>

      {/* Quick test section */}
      {/* <div
        style={{
          marginTop: "20px",
          padding: "15px",
          backgroundColor: "#f8f9fa",
          borderRadius: "4px",
          border: "1px solid #e9ecef",
        }}
      > */}
      {/* <h4>Quick Test:</h4>
        <button
          onClick={() => {
            setPhoneNumber("+1234567890");
            setMessage("Hello, this is a test message!");
          }}
          style={{
            padding: "8px 16px",
            backgroundColor: "#e9ecef",
            border: "1px solid #ccc",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          Fill Test Data
        </button> */}
      {/* </div> */}
    </div>
  );
};

export default WhatsAppOpener;
